/* Y2B UX Enhancements */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Scroll to top on page navigation */
  var scrollTarget = document.querySelector('.page-wrapper') || window;
  if (scrollTarget !== window && scrollTarget.scrollTop > 0) {
    scrollTarget.scrollTop = 0;
  }

  /* 2. Fade-in handled by ytb-animations.js — no duplicate here */

  /* 18. Preload hero image — handled via HTML attribute, but ensure scroll parent is ready */

  /* 19. Haptic feedback on Add to Cart */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-to-cart-button, [class*="fc-atc"], [class*="fc-quick-btn"], .sticky-add-to-cart__button');
    if (btn && navigator.vibrate) {
      navigator.vibrate(10);
    }
  });

  /* 20. WhatsApp float — slide in after 3s */
  var waFloat = document.querySelector('.y2b-wa-float');
  if (waFloat) {
    setTimeout(function () {
      waFloat.classList.add('visible');
    }, 3000);
  }

  /* Back to top button */
  var backBtn = document.querySelector('.y2b-back-top');
  if (backBtn) {
    var pw = document.querySelector('.page-wrapper') || window;
    function checkScroll() {
      var scrollPos = pw === window ? window.scrollY : pw.scrollTop;
      if (scrollPos > window.innerHeight) {
        backBtn.classList.add('visible');
      } else {
        backBtn.classList.remove('visible');
      }
    }
    pw.addEventListener('scroll', checkScroll, { passive: true });
    backBtn.addEventListener('click', function () {
      if (pw === window) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        pw.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
})();
